import React from 'react';

import ChildrenBooks from '@app/components/Pages/Children/ChildrenBooks';
import EducationalBooks from '@app/components/Pages/Children/EducationalBooks';
import Background from '@app/components/UI/Background/Background';
import Card from '@app/components/UI/Card/Card';
import EmailForm from '@app/components/UI/ContactForms/EmailForm/EmailForm';
import HelmetProvider from '@app/components/UI/Helmet/HelmetCustom';
import Media from '@app/components/UI/Media/Media';
import Subscribe from '@app/components/UI/Subscribe/Subscribe';
import ScrollBlockDown from '@app/imgs/ScrollBlockDown';

import '@app/scss/pages/Children.scss';

const Children = () => {
	return (
		<HelmetProvider title="Children">
			<div className="is-relative pages">
				<Background />
				<div className="children-page">
					<div className="first-screen text-center">
						<div className="container is-relative">
							<img className="img-1" src="/images/children-first-bg.png" alt="image 1" />
							<h1>Welcome to my world of enchanting tales for children, where imagination knows no bounds!</h1>
							<ScrollBlockDown />
							<img className="img-2" src="/images/first-screen-2.png" alt="image 2" />
						</div>
					</div>
					<div className="white-opacity">
						<ChildrenBooks />
						<div id="about" className="about scroll-landing">
							<div className="container">
								<Card
									image={
										<>
											<img src="/images/Group 64.png" alt="Dr. Mary" />
										</>
									}
									text={
										<div className="h3 text-center">
											Dr. Mary, a veterinarian with an unwavering love for the diverse animal inhabitants of our planet,
											embarked on her journey as a children's book author at the tender age of 12. Her passion endures,
											as she dedicates herself to crafting enchanting children's stories, with each tale celebrating a
											delightful animal at its heart.
										</div>
									}
								/>
							</div>
						</div>
						<div id="free-goodies" className="form-coloring scroll-landing">
							<div className="coloring-bg">
								<div className="cat">
									<img src="/images/C_23-2.png" alt="cat" />
								</div>
								<div className="form text-center">
									<h2>Free Goodies</h2>
									<p>Get free coloring pages in PDF format for your little artist. Just enter your email!</p>
									<Subscribe type={1} buttonText="Get free pages" />
								</div>
								<div className="dog">
									<img src="/images/23-9.png" alt="dog" />
								</div>
							</div>
						</div>
						<div id="educational-books" className="educational-books scroll-landing">
							<div className="container">
								<h2 className="landing-page-h2">Educational Books</h2>
								<EducationalBooks />
							</div>
						</div>
					</div>
					<div id="contact" className="children-contact is-relative scroll-landing">
						<div className="container">
							<Card
								image={
									<>
										<div className="text">
											<h2>Contact</h2>
											<p className="text-secondary">Have a question for Dr. Mary – don’t hesitate to send a message:</p>
										</div>
										<div className="block-media">
											<div className="h3">Follow me on social media</div>
											<div className="media">
												<Media />
											</div>
										</div>
									</>
								}
								text={
									<div className="contact-form">
										<div className="h2 text-center">Email Dr. Mary</div>
										<EmailForm textDone="Thank you for your email submission. We will get back to you shortly!" />
									</div>
								}
							/>
						</div>
					</div>
				</div>
			</div>
		</HelmetProvider>
	);
};

export default Children;
